import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { formatMoneda, formatoMonto, seleccionarCampo, validaMonto, validarCantidad, validarCantidaddos } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import useTableScroll from "../useTableScroll";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import ActualizarMoviles from "./gestionarMoviles";

const VisualizarMoviles = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const accbtncntxcobrar = JSON.parse(
    sessionStorage.getItem("accbtncntxcobrarc")
  );
  const cmbCedula = ["J", "V", "G", "P"];
  const headCells = [
    { label: "PLACA", textAlign: "center", width: "50px" },
    { label: "MARCA", textAlign: "center", width: "80px" },
    { label: "MODELO", textAlign: "center", width: "80px" },
    { label: "USO", textAlign: "center", width: "250px" },
    { label: "ACCION", textAlign: "center", width: "50px" },
  ];

  const txtCliente = useRef();
  const txtDespachado = useRef();
  const txtDevuelto = useRef([]);
  const txtCantidad = useRef([]);
  const txtPendientes = useRef();
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtNotaEntrega = useRef();
  const txtTotalVacios = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [clientemoviles, setClientemoviles] = useState([]);
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);
  const [opera, setOpera] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const blanquear = () => {
    setMostrar(false);

  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };


  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
    if (props.ope !== 1) {
      props.onRenderizar();
    }
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    props.onRenderizar();
  };

  const seleccionarMoviles = (id) => {
    let campos = "*";
    let nomtab = "moviles";
    let nomid = "placa";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idmovil > 0) {
            setClientemoviles(response.data);
            setMostrar(true);
          } else {
            setClientemoviles([]);
            setMostrar(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };
  

  const onGestionar = (item, ope) => (e) => {
    
    if (ope === 4) {
      seleccionarMoviles(item.placa);
      setOpera(ope);
    } else if (ope === 2) {
      seleccionarMoviles(item.placa);
      setOpera(ope);
    } else {
      seleccionarMoviles(item.placa);
      setOpera(ope);
    }

  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="xl"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope !== 1) {

          setRecords(props.data);
          cmbRif.current.value = props.data[0].cedularespo.substring(0, 1);
          txtRif.current.value = props.data[0].cedularespo.substring(1, 12);
          txtCliente.current.value = props.data[0].nombrerespo;

        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>{props.ope === 4 ? "Gestion de Moviles (CONSULTA)" : props.ope === 2 ? "Gestion de Moviles (MODIFICAR)" : "Gestion de Moviles (ELIMINAR)"}</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12" style={{ margin: 0 }}>
            <div className="col-md-12 row border-azul mx-auto rounded py-1">

              <div
                className="col-12 mx-auto mb-1 px-0"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul border-4 rounded py-2">

                  <span className="fw-bold mb-1">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-2 col-3 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled
                      maxLength={12}
                      type="text"
                      className="form-control fs-6 px-1"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-9 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCliente}
                    />
                  </div>
                </div>
              </div>

              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 190,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden table-bordered">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="align-middle bg-light text-center p-2">
                            {item.placa}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-center p-2 pl-2"
                            style={{ width: "100px" }}
                          >
                            {item.marca}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-2"
                            style={{ width: "100px" }}
                          >
                            {item.modelo}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light p-2 pr-2"
                            style={{ width: "500px" }}
                          >
                            {item.uso}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-2 pr-2"
                            style={{ width: "30px" }}
                          >
                            {props.ope === 4 ? <button
                              className="btn btn-sm btn-info rounded mx-1"
                              title="Visualizar Moviles por Cliente"
                              onClick={onGestionar(item, 4)}
                            >
                              <i className="fas fa-eye" />
                            </button> : props.ope === 2 ? <button
                              className="btn btn-sm btn-warning rounded mx-1"
                              title="Modificar Movil por Cliente"
                              onClick={onGestionar(item, 2)}
                            >
                              <i className="fas fa-pencil-alt" />
                            </button> : <button
                              className="btn btn-sm btn-danger rounded"
                              title="Eliminar Movil por Cliente"
                              onClick={onGestionar(item, 3)}
                            >
                              <i className="fa fa-trash" />
                            </button>}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <ActualizarMoviles
        show={mostrar}
        ope={opera}
        data={clientemoviles}
        onHideCancelaDos={() => {cancelar()}}
        onHideCancelar={() => {
          setMostrar(false);
        }}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>Cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default VisualizarMoviles;



// WEBPACK FOOTER //
// ./src/components/servicios/actualizarMoviles.js